import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CreateOrEditUserDTO } from 'app/back-office/shared/models/users/user.model';
import { environment } from 'environments/environment';
import { UserInfo } from '../models/user-info.model';
import { BasicHttpClientService } from './basic-http-client.service';

export interface Locale {
  lang: string;
  data: Object;
}

@Injectable({
  providedIn: 'root'
})
export class CoreTranslationService {

  private baseUrl: string;

  constructor(
    private _translateService: TranslateService,
    private _httpClient: BasicHttpClientService
  ) {
    this.baseUrl = environment.urls.apiUrl.url;
  }

  // Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Translate
   *
   * @param {Locale} args
   */
  translate(...args: Locale[]): void {
    const locales = [...args];

    locales.forEach(locale => {
      // use setTranslation() with the third argument value as true to append translations instead of replacing them
      this._translateService.setTranslation(locale.lang, locale.data, true);
    });
  }

  updateUserCulture(user: CreateOrEditUserDTO, loaderId: string) {
    return this._httpClient.put<UserInfo>(this.baseUrl + `/users/${user.id}`, user, null, loaderId);
  }
}
